import React from 'react';

import { Grid, Typography, makeStyles } from '@gogame/components';

import Comment from './Comment';

const useStyles = makeStyles(() => ({
  root: {
    padding: '32px 0 0 0',
  },
  own: {
    width: ({ maxFormWidth }) => `${maxFormWidth}px`,
  },
}));

export const CommentsList = ({
  data = [],
  onEdit,
  onDelete,
  minHeight = '500px',
  maxFormWidth = '100%',
  itemSize,
  onLoadSuggestions,
}) => {
  const classes = useStyles({ maxFormWidth });
  const handleDelete = (id, author, date) => () => {
    onDelete({ id, author, date });
  };

  if (!data.length) {
    return (
      <Grid
        container
        alignItems={'center'}
        justifyContent={'center'}
        style={{ minHeight }}
      >
        <Grid item>
          <Typography color={'textSecondary'}>No comments</Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container className={classes.root} spacing={3}>
      {data.map(({ id, author, createdDate, text, actions = [] }) => {
        const ownComment = actions.length;
        return ownComment ? (
          <Grid item key={id} className={classes.own} xs={itemSize || 12}>
            <Comment
              id={id}
              author={author.name}
              date={createdDate}
              message={text}
              onDelete={handleDelete(id, author, createdDate)}
              onComment={onEdit}
              withActions={true}
              autoFocus={true}
              onLoadSuggestions={onLoadSuggestions}
            />
          </Grid>
        ) : (
          <Grid item key={id} xs={itemSize || 12}>
            <Comment
              id={id}
              author={author.name}
              date={createdDate}
              message={text}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
